export const DIAG = {
  stroke: "Rééducation post-AVC", tbi: "Traumatisme crânien", parkinson: "Maladie de Parkinson",
  ms: "Sclérose en plaques", orthopedic: "Rééducation orthopédique", other: "Autre",
};
export const HAND = { none: "Pas de déficit", mild: "Déficit léger", moderate: "Déficit modéré", severe: "Déficit sévère" };
export const BALANCE = { good: "Bon", moderate: "Modéré", poor: "Faible" };
export const WALK = { independent: "Autonome", with_aid: "Avec aide technique", assisted: "Avec tierce personne", non_ambulatory: "Non ambulant" };
export const PRIORITY = {
  right_upper_limb: "Membre supérieur droit", left_upper_limb: "Membre supérieur gauche",
  right_lower_limb: "Membre inférieur droit", left_lower_limb: "Membre inférieur gauche", bilateral: "Bilatéral",
};
export const MISSION_ICON = { water_bottle: "water_bottle", fruit: "fruit", basket: "basket", villager: "villager", branch: "branch" };
export const METRIC_FR = {
  reach_cm: "Atteinte fonctionnelle (cm)", shoulder_flexion: "Flexion d'épaule (°)", shoulder_abduction: "Abduction d'épaule (°)",
};
export const INTERACTION_FR = { tap: "Toucher", drag: "Glisser-déposer", hold: "Maintien", slow_drag: "Glissement lent contrôlé" };
export const ITEM_FR = { gourde: "Gourde en calebasse", panier_tresse: "Panier tressé", bracelet_perles: "Bracelet de perles" };
export const ANIMAL_FR = { calao: "Calao", pintade: "Pintade", tisserin: "Tisserin" };
